module.exports = __webpack_public_path__ + "img/square-up.0d8fb19d.svg";